import { saveAs } from "file-saver";
import {
  layoutCola_compound,
  layoutCola_simple,
  layoutFCOSE,
} from "./layoutParams";
import { overlapRemoval } from "./overlapRemoval";
import _ from "lodash";

class Callbacks {
  constructor(cy) {
    this.cy = cy;

    this.resetZoom = this.resetZoom.bind(this);
    this.resize = this.resize.bind(this);
    this.enhancesLayoutSimple = this.enhancesLayoutSimple.bind(this);
    this.enhancesLayoutCompound = this.enhancesLayoutCompound.bind(this);
    this.resetLayoutSimple = this.resetLayoutSimple.bind(this);
    this.resetLayoutCompound = this.resetLayoutCompound.bind(this);
    this.downloadJSON = this.downloadJSON.bind(this);
    this.getCyElements = this.getCyElements.bind(this);
    this.savePNG = this.savePNG.bind(this);
    this.overlapRemoval = this.overlapRemovalImpl.bind(this);
    this.searchNode = this.searchNode.bind(this);
    this.highlightNodesByCompound = this.highlightNodesByCompound.bind(this);
    this.removeAllHighlights = this.removeAllHighlights.bind(this);
  }

  resetZoom() {
    this.cy.fit(50);
  }

  resize() {
    this.cy.resize();
  }

  enhancesLayoutSimple() {
    this.cy.layout(layoutCola_simple).run();
  }

  enhancesLayoutCompound() {
    this.cy.layout(layoutCola_compound).run();
  }

  resetLayoutSimple() {
    this.cy.layout(layoutFCOSE).run();
    this.cy.layout(layoutCola_simple).run();
  }

  resetLayoutCompound() {
    this.cy.layout(layoutFCOSE).run();
    this.cy.layout(layoutCola_compound).run();
  }

  downloadJSON() {
    // saveJson(this.cy.json());
    saveJson(this.cy.elements().jsons());
  }

  getCyElements() {
    return this.cy.elements().jsons();
  }

  savePNG() {
    saveAs(this.cy.png({ full: true }), "network.png");
  }

  overlapRemovalImpl() {
    overlapRemoval(this.cy);
  }

  searchNode(query) {
    const lcquery = query.toLowerCase();
    let allNodes = this.cy.nodes();
    let counter = 0;
    if (lcquery !== "") {
      allNodes.forEach((node) => {
        let label = node.data().label.toLowerCase();
        node.unselect();
        node.removeClass("searched");
        if (label.includes(lcquery)) {
          counter += 1;
          node.addClass("searched");
        }
      });
    } else {
      counter = 1;
      allNodes.forEach((node) => {
        node.removeClass("searched");
      });
    }

    return counter !== 0;
  }

  highlightNodesByCompound(location) {
    highlightNodeLocation(this.cy, location);
    return 0;
  }

  removeAllHighlights() {
    highlightNodeLocation.cancel();
    this.cy.elements().removeClass("semitransp");
    this.cy.elements().removeClass("highlight");
  }
}

function saveJson(json) {
  const jsonBlob = new Blob([JSON.stringify(json)], {
    type: "application/javascript;charset=utf-8",
  });
  saveAs(jsonBlob, "network.json");
}

export default Callbacks;

let highlightNodeLocation = _.debounce((cy, location) => {
  // Fonte: https://github.com/PathwayCommons/app-ui/blob/0b615e94829217336113de0fcedb22b0d6c142bf/src/client/features/paint/cy/events.js#L66
  let elesToHighlight = cy.collection();

  cy.nodes().forEach((e) => {
    if (e.data().location === location && e.data().node_type !== "powernode") {
      elesToHighlight.merge(e.ancestors());
      elesToHighlight = elesToHighlight.union(cy.$(`#${e.data().id}`));
    }
  });

  //Add highlighted class to node & its neighbourhood, unhighlighted to everything else
  cy.elements().addClass("semitransp");
  elesToHighlight.forEach((ele) => {
    ele.removeClass("semitransp");
    ele.addClass("highlight");
  });
}, 500);
